import React, { FC } from 'react'

type IconProps = {
  className?: string
  size?: number
}
export const YouTubeIcon: FC<IconProps> = ({ className, size = 40 }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      viewBox={'0 0 40 40'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M36.3438 11.8125C37.0938 14.4375 37.0938 20.0625 37.0938 20.0625C37.0938 20.0625 37.0938 25.625 36.3438 28.3125C35.9688 29.8125 34.7812 30.9375 33.3438 31.3125C30.6562 32 20.0312 32 20.0312 32C20.0312 32 9.34375 32 6.65625 31.3125C5.21875 30.9375 4.03125 29.8125 3.65625 28.3125C2.90625 25.625 2.90625 20.0625 2.90625 20.0625C2.90625 20.0625 2.90625 14.4375 3.65625 11.8125C4.03125 10.3125 5.21875 9.125 6.65625 8.75C9.34375 8 20.0312 8 20.0312 8C20.0312 8 30.6562 8 33.3438 8.75C34.7812 9.125 35.9688 10.3125 36.3438 11.8125ZM16.5312 25.125L25.4062 20.0625L16.5312 15V25.125Z'
        }
        fill={'#141414'}
      />
    </svg>
  )
}
